// Dark inks on a white label only: each keeps at least 7:1 contrast with
// white, so every phone camera reads the code. Never a light ink, never a
// coloured background.
export const labelColours = [
  { ink: "#000000", key: "black", name: "Black" },
  { ink: "#065f46", key: "green", name: "Green" },
  { ink: "#1e3a8a", key: "blue", name: "Blue" },
  { ink: "#991b1b", key: "red", name: "Red" },
  { ink: "#581c87", key: "purple", name: "Purple" },
] as const;

export type LabelColour = (typeof labelColours)[number];

const storageKey = "safeplate.label-colour";

export function labelColour(key: unknown): LabelColour {
  return labelColours.find((colour) => colour.key === key) ?? labelColours[0];
}

export function storedLabelColour(): LabelColour {
  try {
    return labelColour(globalThis.localStorage?.getItem(storageKey));
  } catch {
    return labelColours[0];
  }
}

export function storeLabelColour(colour: LabelColour): void {
  try {
    globalThis.localStorage?.setItem(storageKey, colour.key);
  } catch {
    // Private browsing: the choice lasts for this page only.
  }
}

// Probes and thermometers travel with the cook; they don't get a label.
export function wantsLabel(item: Record<string, unknown>): boolean {
  return item["asset_type"] !== "probe" && item["asset_type"] !== "thermometer";
}
